/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable:no-any */ // We need to be able to reference any component

import {
  Component,
  OnDestroy,
  Input,
  ViewChild,
  AfterContentInit,
  ViewContainerRef,
} from '@angular/core';
import { DynamicItem } from '@core/aem/models/dynamic-item';
import { DynamicHostDirective } from '@core/aem/directives/dynamic-host.directive';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';

/**
 * Component used to create Dynamic Components
 * @access private
 */
@Component({
  selector: 'tmo-dynamic',
  template: `<ng-template tmoDynamicHost></ng-template>`,
})
export class DynamicComponent implements AfterContentInit, OnDestroy {
  @Input() public item: DynamicItem<Object>;
  @ViewChild(DynamicHostDirective, { static: true }) public tmoDynamicHost: DynamicHostDirective;
  private interval: number;

  constructor(private ViewContainerRef: ViewContainerRef) {
    this.interval = 0;
  }

  /**
   * Called after the component is initialized
   * @returns void
   */
  public ngAfterContentInit(): void {
    if (this.item) {
      this.loadComponent();
    }
  }

  /**
   * Unsubscribes for all subscriptions
   */
  public ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  /**
   * called when the dynaic component is initalized.
   * @returns void
   */
  public loadComponent(): void {
    const viewContainerRef: ViewContainerRef = this.tmoDynamicHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(this.item.component);
    if (this.item.data) {
      (<AuthorableComponent<Object>>componentRef.instance).setData(this.item.data);
    }
  }
}
